
(function($) {
  'use strict';

  var user = null;


  /**
   * userを取得
   **/
  function getUser() {
    if ( user ) {
      return user;
    }

    //前回アクセス時のユーザーデータを復元
    var user_data = localStorage.getItem('user');

    if ( user_data ) {
      user = JSON.parse(user_data);
    } else { 
      //新規ユーザー作成
      user = {
        id : getUuid(),
        name : '名無しさん',
        comment_read : {},
        post_read : {},
      };

      //古い仕様に対応する
      var comment_author = localStorage.getItem('comment_author');
      if ( comment_author ) {
        user.name = comment_author;
      }
    }

    if ( !user.id_hash ) { 
      getUserIdHash(user.id);
    }

    return user;
  }

  function getUserIdHash(user_id) {
      $.ajax({
        url: moko.ajaxurl,
        type: 'POST',
        dataType: 'json',
        timeout: 10000,
        cache : false,
        data: {
          'action': 'user_id_hash',
          'user_id' : user_id,
        }
      }).done( function( data ) {
        //console.log('user_id_hash',data);
        user.id_hash=data.user_id_hash;
        saveUser(user);
      });
 
  }

  /**
   * UUIDを生成する
   **/
  function getUuid(){
    var strong = 99;
    var time = new Date().getTime() ;
    return Math.floor(strong*Math.random()).toString(16) + time.toString(16);
  }

  //console.log('user',user);

  /**
   * ローカルDBへユーザーデータを保存
   **/
  function saveUser(user) {
    var user_data = JSON.stringify(user);
    localStorage.setItem('user', user_data );
  };

  moko.getUser = getUser;
  moko.saveUser = saveUser;


})(jQuery);
